module.exports = __webpack_public_path__ + "img/o.a9b620bb.jpg";